export default (text = "", keywords) => {
  return keywords && text.toLowerCase().includes(keywords.toLowerCase())
}



// WEBPACK FOOTER //
// ./src/app/utils/highlightable.js